module.exports = __webpack_public_path__ + "img/zbjx.a0616eaa.png";